<template>
  <div class="flex flex-col" :class="{ 'pb-4': !noMargin }">
    <div class="text-sm flex place-content-between items-center text-n-800 dark:text-n-0">
      <div v-if="label || description">
        {{ label }}
        <span v-if="mandatory" class="text-r-500">*</span>
        <span v-if="optional" class="text-xs">
          {{ `(${$t('core.optional')})` }}
        </span>
        <span v-if="description" class="text-n-400 dark:text-n-500">
          {{ description }}
        </span>
      </div>
      <slot name="top-left"></slot>
    </div>
    <div class="flex pt-2">
      <slot />
    </div>
    <slot name="bottom"></slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string
  mandatory?: boolean
  optional?: boolean
  description?: string
  /**
   * A boolean flag to determine whether to remove the margin.
   * If set to `true`, the component will render without any margin.
   */
  noMargin?: boolean
}

withDefaults(defineProps<Props>(), {
  label: '',
  mandatory: false,
  optional: false,
  description: '',
  noMargin: false
})
</script>
